import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section id="contact" className="relative py-16 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9becfb910a4a245f6064d2a2118fde6a.jpg"
          alt="Las Vegas Sunset"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-8 lg:mb-0"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
              Launch Your
              <br />
              Campaign
              <br />
              Today
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-right"
          >
            <p className="text-base md:text-lg font-light text-white mb-1">
              Schedule a free consultation
            </p>
            <p className="text-base md:text-lg font-light text-white">
              to explore the best strategy for your brand
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-10"
        >
          <Link
            to="/en/advertise#inquiry-form"
            className="inline-flex items-center gap-3 px-6 py-3 bg-white rounded-full hover:shadow-2xl transition-all cursor-pointer group"
          >
            <span className="text-black font-semibold text-sm whitespace-nowrap">
              Get Started
            </span>
            <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-arrow-right-line text-white text-lg"></i>
            </div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
